import type { FaqItem } from '../types/content'
import { siteConfig } from './siteConfig'

// Les questions dont la réponse est vide ne sont pas affichées.
export const faqs: FaqItem[] = [
  {
    question: 'Faut-il savoir dessiner ?',
    answer:
      'Non. Vous placez un modèle imprimé sous votre support transparent et vous suivez ses lignes : c’est le modèle qui guide votre tracé.',
  },
  {
    question: 'Est-ce adapté aux débutants ?',
    answer:
      'Oui. Le parcours commence par le choix du matériel et des exercices simples, avant les premiers projets guidés.',
  },
  {
    question: 'Que contient le pack ?',
    answer:
      'Six ressources numériques : le guide L’Atelier du Faux Vitrail, Bien choisir son matériel, Mes modèles à tracer, Mes Premières Créations, Mon Carnet de Couleurs et 100+ modèles de faux vitrail.',
  },
  {
    question:
      'Quelle est la différence entre les modèles d’entraînement et les 100+ modèles ?',
    answer:
      'Les modèles à tracer servent à vous exercer aux lignes, aux courbes et aux contours. La bibliothèque de plus de 100 modèles vous offre ensuite un large choix de motifs pour vos créations.',
  },
  {
    question: 'Les 100+ modèles comprennent-ils chacun un tutoriel ?',
    answer:
      'Non. Le pack comprend une bibliothèque de modèles à tracer et, séparément, six projets guidés pas à pas dans Mes Premières Créations.',
  },
  {
    question: 'Le matériel est-il inclus ?',
    answer:
      'Non. Il s’agit d’un produit numérique : peintures, cernes, supports et outils sont à prévoir séparément. Le guide Bien choisir son matériel vous aide à les sélectionner.',
  },
  {
    question: 'Faut-il découper ou souder du verre ?',
    answer:
      'Non. La technique enseignée consiste à tracer des contours et à peindre sur un support transparent adapté. Aucune découpe ni soudure n’est nécessaire.',
  },
  {
    question: 'Dois-je imprimer tous les documents ?',
    answer:
      'Non. Les guides peuvent se consulter sur écran ; vous imprimez seulement les modèles que vous choisissez de réaliser.',
  },
  {
    question: 'Comment recevoir les fichiers ?',
    answer: siteConfig.deliveryAnswer,
  },
  {
    question: 'Puis-je vendre mes créations ?',
    answer: siteConfig.commercialUseAnswer,
  },
]
